import { useDroppable } from "@dnd-kit/core";

export const DiaCalendario = ({ id, children, dia, esHoy = false, eventCount = 0, abrirFormularioCrearEvento }) => {
	const { setNodeRef, isOver } = useDroppable({ id });
	const tieneContenido = eventCount > 0;
	const [, mm, yyyy] = id.split("-").map(Number);
	const fechaObj = new Date(yyyy, mm - 1, dia);
	const nombresDias = ["dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte", "diumenge"];

	let diaSemana = fechaObj.getDay();
	diaSemana = diaSemana === 0 ? 6 : diaSemana - 1;
	const nombreDia = nombresDias[diaSemana];
	const abrirDia = (e) => {
		const target = e.target;
		if (target.closest?.(".calendar-event-card") || target.closest?.(".calendar-more")) {
			return;
		}
		abrirFormularioCrearEvento(id);
	};

	return (
		<div
			ref={setNodeRef}
			className={`calendar-day ${esHoy ? "calendar-day-today" : ""} ${tieneContenido ? "calendar-day-with-content" : ""} ${isOver ? "calendar-day-over" : ""}`}
			onClick={abrirDia}
		>
			<div className="calendar-day-header">
				<div className="calendar-day-date">
					<span className="calendar-day-number">{dia}</span>
					<span className="calendar-day-name">{nombreDia}</span>
				</div>
				{eventCount > 0 && (
					<span className="calendar-day-count">{eventCount}</span>
				)}
			</div>
			<div className="calendar-day-body">{children}</div>
		</div>
	);
};
